var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"skip-link",attrs:{"href":"#main-content"}},[_vm._v("\n  Skip to main content\n")])}
var staticRenderFns = []

export { render, staticRenderFns }